import { render, staticRenderFns } from "./StaffPage.vue?vue&type=template&id=a6134e44&"
import script from "./StaffPage.vue?vue&type=script&lang=js&"
export * from "./StaffPage.vue?vue&type=script&lang=js&"
import style0 from "./StaffPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports